import Modal from '../../../../component/modal/Modal';
import Button from '../../../../component/ui/Button';

const CustomAlertModel = ({
	setIsAlertModelOpen,
	isAlertModelOpen,
	customText,
	objectSelectedList,
	objectLength,
	handleBulk,
	saleTypeName,
	title,
}) => {
	return (
		<Modal
			className="deleteVendorsModal"
			title={title}
			isOpen={isAlertModelOpen}
			onClose={() => {
				setIsAlertModelOpen(false);
			}}
			cancelButton={() => {
				setIsAlertModelOpen(false);
			}}
		>
			<p
				style={{
					textAlign: 'center',
					backgroundColor: '#E6F5FF',
					padding: '10px',
					borderRadius: '5px',
					fontWeight: '600',
					color: 'black',
				}}
			>
				{customText} {objectLength} {saleTypeName}?
			</p>
			<div
				style={{
					padding: '0px 10px',
				}}
			>
				{objectSelectedList?.length > 0 &&
					objectSelectedList?.map((name, index) => (
						<p
							style={{
								fontSize: '13px',
								fontWeight: '500',
							}}
							key={name + index}
						>
							{index + 1}. {name}
						</p>
					))}
			</div>

			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					gap: 10,
					justifyContent: 'end',
				}}
			>
				<Button
					type="button"
					className="mt-0 btn-gray add-pro"
					button="Cancel"
					onClick={() => {
						setIsAlertModelOpen(false);
					}}
				/>

				<Button
					type="button"
					button="Confirm"
					className="mt-0 px-4 btn-danger relative"
					onClick={handleBulk}
				/>
			</div>
		</Modal>
	);
};
export default CustomAlertModel;
